import { SelectionActionButton } from 'components/selection-action-button/selection-action-button';
import DigitalTrapsFiltersContainer from '@features/regional-overview/digital-traps/components/digital-traps-filters/digital-traps-filters';
import EmptyState from '@features/regional-overview/digital-traps/components/empty-state';
import TabLoading from '@features/regional-overview/digital-traps/components/tab-loading';
import { DigitalTrapFilterType } from '@features/regional-overview/digital-traps/domain';
import { NETWORK_MANAGEMENT_TAB } from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyStateWrapper, FilterWrapper } from '../../trap-management-tabs.style';
import LocationModal from './location-modal';
import ManageAssetGroup from './manage-asset-group';
import NetworkCardList from './network-card-list';
import { useNetworkManagementData } from './network-management.hook';
import { mapSelectedTrapsToAssetGroup } from './network-management.utils';
import { useNetworkManagementStore } from './network-management.zustand';

const ENABLED_FILTERS = [DigitalTrapFilterType.TEXT_SEARCH];

const NetworkManagement = () => {
  const [t] = useTranslation();
  const { networks, isLoading } = useNetworkManagementData();
  const hasTrapData = useMemo(() => networks.length > 0, [networks]);
  const { isModalOpen, editingGroup, selectedTrapIDs, selectedTraps, setSelectedTraps, setEditingGroup } = useNetworkManagementStore();

  if (isLoading) {
    return <TabLoading text={t('pages.regional_overview.digital_traps.network_management.loading_text')} />;
  }

  const handleEditConfiguration = () => {
    setEditingGroup(mapSelectedTrapsToAssetGroup(selectedTraps, 'ASSIGN_TRAPS'));
  };

  return (
    <>
      <FilterWrapper>
        <DigitalTrapsFiltersContainer enabledFilters={ENABLED_FILTERS} context='Network Management' />
      </FilterWrapper>
      {!hasTrapData && (
        <EmptyStateWrapper>
          <EmptyState context='search' />
        </EmptyStateWrapper>
      )}
      {hasTrapData && <NetworkCardList dataTestId={NETWORK_MANAGEMENT_TAB} groups={networks} />}
      {isModalOpen && <LocationModal />}
      {editingGroup && <ManageAssetGroup />}
      {selectedTrapIDs.length > 0 && (
        <SelectionActionButton
          selectionCount={selectedTrapIDs.length}
          onClickButton={handleEditConfiguration}
          onClearSelections={() => setSelectedTraps([])}
          selectionsLocalizationPath='pages.regional_overview.digital_traps.network_management.selected_traps'
          buttonText={t('pages.regional_overview.digital_traps.network_management.assign_traps_button')}
        />
      )}
    </>
  );
};

export default NetworkManagement;
